import React from 'react';

import { useOptionState } from 'src/hooks/useOptionState';
import type { Option } from 'src/types';
import { getArrayElement } from 'src/utils/getArrayElement';

const limitOptions: Option<number>[] = [
  { label: '10', value: 10 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: '1000', value: 1000 },
  { label: 'common:UNLIMITED', value: 100000 },
];

const defaultLimitOption: Option<number> = getArrayElement(limitOptions, 2);

type LimitOptions = {
  limitOptions: Option<number>[];
  selectedLimitOption: Option<number>;
  handleLimitChange: (val: unknown) => void;
  setLimitOption: React.Dispatch<React.SetStateAction<Option<number> | null>>;
};

export const useLimitOptions = (): LimitOptions => {
  const [selectedLimitOption, handleLimitChange, setLimitOption] = useOptionState<number>(defaultLimitOption);
  return React.useMemo(
    () => ({
      limitOptions,
      selectedLimitOption: selectedLimitOption || defaultLimitOption,
      handleLimitChange,
      setLimitOption,
    }),
    [selectedLimitOption, handleLimitChange, setLimitOption],
  );
};
